import { cellRenderHolderReportGrid, cellRenderParseData } from '../../utils/functions';

/** Список полей */
const columnDataGridReports = [
  {
    dataField: 'docId',
    dataType: 'string',
    caption: 'Номер отчета',
    cellRender: cellRenderHolderReportGrid
  },
  {
    dataField: 'docDate',
    dataType: 'date',
    caption: 'Дата отчета',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'docStatusDesc',
    dataType: 'string',
    caption: 'Статус отчета (описание)'
  }
];

export default columnDataGridReports;
